import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export enum ContactVersionEnum {
  CENTER_WITH_TRANSPORT = 'CENTER_WITH_TRANSPORT',
  CENTER_WITHOUT_TRANSPORT = 'CENTER_WITHOUT_TRANSPORT',
  HOST_FAMILY_WITH_TRANSPORT = 'HOST_FAMILY_WITH_TRANSPORT',
  HOST_FAMILY_WITHOUT_TRANSPORT = 'HOST_FAMILY_WITHOUT_TRANSPORT'
}

export function getContactVersion(enrollmentId: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.getContactVersion.url, { id: enrollmentId }))
    .get<{ contactVersion: ContactVersionEnum }>()
}
